export default __webpack_public_path__ + "static/slide-bg-image-d2863a6f5144f985b1f58b107610d625.png";